import EmailNotVerifiedMessage from './EmailNotVerifiedMessage';

import { Dialog } from '@headlessui/react';

const EmailNotVerifiedDialog: React.FC<any> = (props: any) => {
  const { isOpen, setIsOpen } = props;

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-[51]"
      >
        <div cy-test-id="email-not-verified-dialog" className="fixed inset-0 overflow-y-auto flex items-center justify-center bg-black/60">
          <Dialog.Panel>
            <div className="unlock-modal bg-a-dark-gray shadow-lg drop-shadow-lg rounded-[5px] pt-10 px-12 pb-12 text-white lg:w-[768px] text-center">
              <p className="block mb-4">
                <EmailNotVerifiedMessage />
              </p>
              <button
                className="rounded-[5px] hover:!bg-[#24C1FF] uppercase eurostile px-5 py-2 bg-a-blue font-semibold tracking-wider text-white mt-4"
                onClick={() => setIsOpen(false)}
              >
                ok
              </button>
            </div>
         </Dialog.Panel>
       </div>
      </Dialog>
    </>
  )
};

export default EmailNotVerifiedDialog;
